import type { Filter, Guard } from '@rehaje/shared'

export function closest<T = any>(value: any, filter: Guard<T>): T | undefined
export function closest<T = any>(value: any, filter: Filter): T | undefined
export function closest(value: any, filter: any) {
  if (typeof value !== 'object' || value === null) return
  if (filter === undefined) return value
  const queue = [value]
  while (queue.length > 0) {
    const parent = queue.shift()
    const parents = parent?.__rr_parents
    if (filter(parent)) return parent
    if (parents === undefined || parents.size === 0) continue
    queue.push(...parents.keys())
  }
}
